export default __webpack_public_path__ + "static/travel-f5bb1db9dd9a65915e70e62b5051151e.jpg";